/*
 * Created Date: Tue, 4th May 2021, 14:33:41 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2021 The Distance
 */

import React from 'react';
import { Button } from 'react-admin';

const ActionButton = ({
  name,
  disabled,
  icon,
  style,
  onClick,
  addLabel,
  basePath,
  variant = 'contained',
  ...rest
}) => {
  return (
    <Button
      label={name}
      disabled={disabled}
      variant={variant}
      onClick={onClick}
      style={style}
      {...rest}
    >
      {icon}
    </Button>
  );
};

ActionButton.defaultProps = { addLabel: false };

export default ActionButton;
